﻿import React, { useState, useEffect } from 'react';
import Diagram, { CustomShape, Nodes, Edges, AutoLayout, Toolbox, Group, PageSize } from 'devextreme-react/diagram';
import { WorkflowAction } from '../../models/Workflow/workflow-action';

import TextBox from 'devextreme-react/text-box';
//import NumberBox from 'devextreme-react/number-box';
import SelectBox from 'devextreme-react/select-box';
//import CheckBox from 'devextreme-react/check-box';
import Button from 'devextreme-react/button';
//import { Popup as DialogPopup } from 'devextreme-react/popup';


import 'devexpress-diagram/dist/dx-diagram.min.css';


const actionTypes: any[] = [
    { id: 1, name: "Start", description: "Start Workflow" },
    { id: 2, name: "Set Variable", description: "Set Variable" },
    { id: 3, name: "IF", description: "Logical IF statement" },
    { id: 4, name: "Stop", description: "Stop Workflow" },
    { id: 5, name: "Email", description: "Send Email" },
    { id: 6, name: "Report", description: "Run Report" }

]

//temp
let newActionId = 100;

export default function WorkflowManagementForm() {
    const [workflowActions, setWorkflowActions] =
        useState<WorkflowAction[]>();

    const [selectedWorkflowAction, setSelectedWorkflowAction] =
        useState<WorkflowAction>();

    const [selectedActionType, setSelectedActionType] =
        useState<any>();

    useEffect(() => {
        getInitWorkflowActions();
    }, []);

    return (
        <div>
            <div id="workflow-diagram-container">
                <div id="workflow-diagram">
                    <Diagram id="diagram" readOnly={true} showGrid={false}
                        height="90vh" simpleView={true}
                        onItemClick={onDiagramItemClick}
                        onOptionChanged={onDiagramOptionChanged}
                        onRequestEditOperation={onDiagramRequestEditOperation}
                        onRequestLayoutUpdate={onDiagramRequestLayoutUpdate}
                        onSelectionChanged={onDiagramSelectionChanged}
                        

                        customShapeRender={customShapeTemplate}>
                        {workflowActions && workflowActions.map((t, idx) => <CustomShape
                            type={`task${t.id}`}                           

                            baseType="rectangle"
                            defaultWidth={1.5}
                            defaultHeight={1}
                            allowEditText={false}
                            allowResize={false}
                            key={idx} />)}

                        <PageSize width={20} />

                        <Nodes dataSource={workflowActions} keyExpr="id" parentKeyExpr="pid" typeExpr={itemTypeExpr} >
                            <AutoLayout type="tree" />
                        </Nodes>

                    </Diagram>
                </div>

                <div id="workflow-diagram-right-pane">
                    <div className="pw-comp-row">
                        {selectedWorkflowAction &&
                            <>
                                <div>Selected Action</div>
                                <div>ID: {selectedWorkflowAction.id}, Name: {selectedWorkflowAction.title} </div>
                            </>
                        }
                    </div>

                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-30">
                            <div className="pw-form-unit-label">Action Type</div>
                            <SelectBox id="gravimetricCalculation" className="selectbox"
                                displayExpr='name' valueExpr='id'
                                dataSource={actionTypes ? actionTypes : []}
                                onValueChanged={onActionTypeItemSelectionChanged}
                                value={selectedActionType && selectedActionType.id ? selectedActionType.id : null} />
                        </div>
                    </div>

                    <div className="pw-comp-row">
                        <Button text="Add Action" onClick={onAddActionClick} />

                    </div>


                </div>

            </div>
        </div>
    );

    function onActionTypeItemSelectionChanged(e: any) {
        const matchingActionType = actionTypes.find(a => a.id === e.value);

        setSelectedActionType(matchingActionType);
    }

    function onAddActionClick() {
        if (selectedWorkflowAction && selectedActionType) {
            newActionId++;

            var newWorkflowActions = [...workflowActions];

            let newAction: WorkflowAction = {
                id: newActionId,
                actionType: 30,
                pid: selectedWorkflowAction.id,
                title: selectedActionType.name,
                status: 0
            };

            // console.log("about to ADD action:");
            // console.log(newAction);

            newWorkflowActions.push(newAction);

            setWorkflowActions(newWorkflowActions);
        }

    }

    function onDiagramItemClick(e: any) {
        console.log("onDiagramItemClick");
        console.log(e);

        if (workflowActions && e.item && e.item.key) {

            const selectedItem = workflowActions.find(a => a.id === e.item.key);

            //console.log("selectedItem:");
            //console.log(selectedItem);

            setSelectedWorkflowAction(selectedItem);

        }
    }

    function onDiagramOptionChanged(e: any) {
        //  console.log("onDiagramOptionChanged");
        //  console.log(e);
    }

    function onDiagramRequestEditOperation(e: any) {
        console.log("onDiagramRequestEditOperation");
        console.log(e);
    }

    function onDiagramRequestLayoutUpdate(e: any) {
        //console.log("onDiagramRequestLayoutUpdate");
        //console.log(e);

        if (e.changes && e.changes.length > 0) {
            console.log("AT 172");

            let newShape = e.changes[0];

            if (newShape.type === "insert") {

                console.log("AT 178");

                newShape.data.title = "NEW";
                newShape.text = "New Text";
            }
        }
    }


    function itemTypeExpr(obj: { id: number; }) {
        return `task${obj.id}`;
    }

    function onDiagramSelectionChanged(e: any) {
        //console.log("onDiagramSelectionChanged");
        //console.log(e);
    }


    function customShapeTemplate(task) {

        console.log("task:");
        console.log(task);

        console.log("selectedWorkflowAction");
        console.log(selectedWorkflowAction);

        const selected = task && task.dataItem && selectedWorkflowAction && selectedWorkflowAction.id === task.dataItem.id; 

        if(selected)
            console.log("MATCH!");

        

        const t = task.dataItem;

        let statusFill = "diagram-header-fill-default";

        if (t.title === "Notification")
            statusFill = "diagram-header-fill-red";
        else {
            if (t.status === "Complete")
                statusFill = "diagram-header-fill-green";
            else if (t.status === "In Process")
                statusFill = "diagram-header-fill-orange";
        }

        const headerCss = `diagram-style1 ${statusFill}`;
        const boxCss = selected ? "diagram-style-selected" : "diagram-style2";

        return (
            <svg>
                <rect width="100%" height="15" x="0" y="0" className={headerCss} />
                <rect width="100%" height="90" x="0" y="15" className={boxCss} />

                <text width="100%" x="50%" y="35" fill="#333" className="diagram-style3">{t.title}</text>
                <text width="100%" x="50%" y="55" fill="#333" className="diagram-style4">{t.id}</text>
                <text width="100%" x="50%" y="75" fill="#333" className="diagram-style5">{t.signOff}</text>
            </svg>
        );

        /*
        
            <svg className="template">
                <text className="template-name" x="50%" y="20%">{employee.Title}</text>
                <text className="template-title" x="50%" y="45%">{employee.Title}</text>
            </svg>
            */
    }

    function getInitWorkflowActions() {
        const tasks: WorkflowAction[] = [
            {
                id: 1,
                title: 'Start',
                actionType: 1,
                status: 1
            }, {
                id: 2,
                pid: 1,
                actionType: 10,
                title: 'Product Planning',
                status: 0,
            }
        ];

        setWorkflowActions(tasks);

    }

}
